<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    fullscreen
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card tile>
      <v-toolbar dense>
        <v-btn @click="closeDialog()" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="subtitle-1">Breakdown by Price</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-badge overlap color="primary darken-4" :content="totalItems"></v-badge>
      </v-toolbar>

      <v-card-text class="mx-0 px-0">
        <v-data-table
          v-model="selected"
          :fixed-header="true"
          :headers="headers"
          :items="breakdownProducts"
          single-expand
          item-key="id"
          class="elevation-1"
          height="65vh"
          :items-per-page="50"
          :footer-props="{
            'items-per-page-options': [50]
          }"
          must-sort
          :search="search"
        >
          <template v-slot:top>
            <div class="d-flex">
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                color="primary darken-4"
                single-line
                hide-details
                filled
                clearable
              ></v-text-field>
            </div>

            <v-divider v-show="isCustomizedTable"></v-divider>
          </template>

          <template v-slot:item.selling_price="{ item }">
            <div class="mx-auto" v-text="item.cost_price"></div>
          </template>

          <template v-slot:item.orders="{ item }">
            <div class="mx-auto" v-text="item.orders"></div>
          </template>

          <template v-slot:item.sales="{ item }">
            <div class="mx-auto" v-text="item.sales"></div>
          </template>

          <template v-slot:item.total="{ item }">
            <div class="mx-auto" v-text="item.total"></div>
          </template>

          <template v-slot:item.evaluation="{ item }">
            <div class="mx-auto" v-text="item.evaluation"></div>
          </template>
        </v-data-table>
      </v-card-text>

      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BreakdownByPriceDialog",
  data() {
    return {
      search: "",
      selected: [],

      headers: [
        {
          text: "Cost Price (GH₵)",
          align: "center",
          value: "cost_price"
        },
        { text: "Orders", align: "center", value: "orders" },
        { text: "Sales", align: "center", value: "sales" },
        { text: "Total", align: "center", value: "total" },
        {
          text: "Total Evaluation (GH₵)",
          align: "center",
          value: "evaluation"
        }
      ]
    };
  },

  components: {},

  methods: {
    closeDialog() {
      this.$store.commit("setBreakdownByPriceDialog", false);
    }
  },

  watch: {},

  computed: {
    showDialog() {
      return this.$store.state.analyses.breakdownByPriceDialog;
    },

    isCustomizedTable() {
      return true;
    },

    breakdownProducts() {
      return this.$store.state.analyses.breakdownItemsByPrice;
    },

    totalItems() {
      return this.$store.state.analyses.breakdownItemsByPrice.length.toString();
    }
  }
};
</script>

<style>
</style>